import { UiState } from '@marketplace-web/shared/ui-state-util'
import { ItemsState } from '@marketplace-web/catalog/catalog-data'

import { ItemsReducerAction, ItemsAction } from './actionTypes'

export const itemsReducer = (state: ItemsState, action: ItemsAction): ItemsState => {
  switch (action.type) {
    case ItemsReducerAction.FETCH_ITEMS_REQUEST: {
      return { ...state, uiState: UiState.Pending }
    }
    case ItemsReducerAction.FETCH_ITEMS_SUCCESS: {
      const { items, pagination, searchTrackingParams, replicaWarning } = action.payload

      return {
        ...state,
        items,
        pagination,
        searchTrackingParams,
        replicaWarning,
        uiState: UiState.Success,
      }
    }
    case ItemsReducerAction.FETCH_ITEMS_FAILURE: {
      return {
        ...state,
        uiState: UiState.Failure,
        error: action.payload.error,
      }
    }
    default:
      return state
  }
}
